function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.998 4.826a8.265 8.265 0 011.48 8.025l2.376 1.057-5.205 1.583-1.718-4.66 2.073.92a5.58 5.58 0 00-7.39-6.799L6.68 2.428a8.273 8.273 0 019.318 2.399zM3.856 14.957a8.265 8.265 0 01-1.479-8.025L0 5.875l5.205-1.583 1.718 4.66-2.072-.92a5.58 5.58 0 007.39 6.799l.934 2.525a8.273 8.273 0 01-9.319-2.4z"
}));

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgSearch;